const {
  VITE_ENVIRONMENT,
  VITE_VERSION,
  VITE_OVERRIDE_API_HOST,
  VITE_API_HOST,
  VITE_REPORT_TO_ANALYTICS,
  VITE_SENTRY_DSN,
  VITE_SENTRY_ENVIRONMENT,
  VITE_TRACES_SAMPLE_RATE,
  VITE_SENTRY_RELEASE,
  VITE_THOUGHT_SPOT_HOST,
  VITE_TS_CARE_TIMER_CALLS_BOARD_ID,
  VITE_TS_TICKET_MANAGEMENT_ID,
  VITE_TS_PATIENTS_ID,
  VITE_PATHWAY_ANALYSIS_ID,
  VITE_PRACTICE_HEALTH_ID,
  VITE_CM_ENROLLMENT_ID,
  VITE_CM_BILLING_ID,
  VITE_MIXPANEL_TOKEN,
  VITE_IS_CANARY,
  VITE_PRODUCTIVITY_ANALYTICS_ID,
  VITE_TASK_MANAGEMENT_ANALYTICS_ID
} = import.meta.env;

export const ENV = VITE_ENVIRONMENT || 'development';
export const VERSION = VITE_VERSION;
export const API_HOST = VITE_OVERRIDE_API_HOST || VITE_API_HOST;
export const REPORT_TO_ANALYTICS = Boolean(VITE_REPORT_TO_ANALYTICS);
export const MIXPANEL_TOKEN = VITE_MIXPANEL_TOKEN || 'fake token required for mixpanel';
export const SENTRY = {
  dsn: VITE_SENTRY_DSN || '',
  environment: VITE_SENTRY_ENVIRONMENT || '',
  ...(Boolean(VITE_TRACES_SAMPLE_RATE) && {
    tracesSampleRate: Number(VITE_TRACES_SAMPLE_RATE)
  }),
  release: VITE_SENTRY_RELEASE || ''
};
export const THOUGHT_SPOT_HOST = VITE_THOUGHT_SPOT_HOST;
export const TS_LIVE_BOARDS_IDS = {
  ticketManagement: VITE_TS_TICKET_MANAGEMENT_ID,
  careTimerCalls: VITE_TS_CARE_TIMER_CALLS_BOARD_ID,
  patients: VITE_TS_PATIENTS_ID,
  pathwayAnalysis: VITE_PATHWAY_ANALYSIS_ID,
  practiceHealth: VITE_PRACTICE_HEALTH_ID,
  careManagementEnrollment: VITE_CM_ENROLLMENT_ID,
  careManagementBilling: VITE_CM_BILLING_ID,
  productivityAnalytics: VITE_PRODUCTIVITY_ANALYTICS_ID,
  taskManagementAnalytics: VITE_TASK_MANAGEMENT_ANALYTICS_ID
};
export const AUTH0_DOMAIN = import.meta.env.VITE_AUTH0_DOMAIN || '';
export const AUTH0_CLIENT_ID = import.meta.env.VITE_AUTH0_CLIENT_ID || '';
export const AUTH0_AUDIENCE = `https://${AUTH0_DOMAIN}/api/v2/`;

export const publicUrls = {
  login: import.meta.env.VITE_LOGIN,
  loginApi: import.meta.env.VITE_LOGIN_API,
  portal: import.meta.env.VITE_PORTAL,
  portalCanary: import.meta.env.VITE_PORTAL_CANARY,
  api: import.meta.env.VITE_API,
  apiCanary: import.meta.env.VITE_API_CANARY
};

export type PublicUrlKey = keyof typeof publicUrls;

/**
 * Get a public URL with https protocol
 */
export const getPublicUrl = (key: PublicUrlKey): string => {
  const url = publicUrls[key];
  if (!url) return '';
  return url.startsWith('http') ? url : `https://${url}`;
};

export const isCanary = VITE_IS_CANARY === 'true';
